import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
} from "@fluentui/react-components";
import { useAppDispatch } from "../../../store";
import { selectIsConnected, setDisconnected } from "../../../taskpane/components/statusBar/store";
import { openToast } from "../../toast/store";
import { useSelector } from "react-redux";
import { setAutoUpdate } from "../store";
import { LocalStorageKeys, SentryCustomData } from "../../../config";
import * as Sentry from "@sentry/react";
import PostHogService from "../../../service/PostHogService";

const useStopConnectionButtonStyles = makeStyles({
  button: {
    alignSelf: "flex-end",
  },
});

const StopConnectionButton = () => {
  const dispatch = useAppDispatch();

  const styles = useStopConnectionButtonStyles();

  const isConnectionEstablished = useSelector(selectIsConnected);

  const handleStopConnection = () => {
    dispatch(setDisconnected());
    dispatch(openToast({ type: "success", message: "Please reconnect to send quotes", title: "Disconnected" }));
    dispatch(setAutoUpdate(false));
    localStorage.setItem(LocalStorageKeys.TOKEN, null);

    Sentry.setExtra(SentryCustomData.AUTO_UPDATE_ENABLED, false);
    Sentry.setExtra(SentryCustomData.CONNECTION_ESTABLISHED, false);

    PostHogService.trackBusinessEvent('disconnection', {
      status: 'disconnection',
      component: 'feed_manager',
      message: 'User disconnected from Cicada platform',
    });

    PostHogService.reset();
  };  

  return (
    <Dialog>
      <DialogTrigger disableButtonEnhancement>
        <Button disabled={!isConnectionEstablished} className={styles.button} appearance="secondary">
          Disconnect
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Stop Connection</DialogTitle>
          <DialogContent>Are you sure to stop the connection to the Cicada platform?</DialogContent>
          <DialogActions>
            <DialogTrigger action="close">
              <Button onClick={handleStopConnection} appearance="primary">
                Disconnect
              </Button>
            </DialogTrigger>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Cancel</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default StopConnectionButton;
